import { OfferingCardTypes } from './OfferingCard.types';

export const OfferingCardStyles = {
  [OfferingCardTypes.default]: {
    /* outer wrapper section */
    outerWrapper: {
      container:
        'whl-w-[343px] whl-p-4 whl-bg-white whl-rounded-[4px] whl-shadow-lg whl-flex whl-flex-col whl-mx-auto whl-min-h-[171px] whl-h-auto',
    },

    /* inner wrapper section */

    innerWrapper: {
      container: 'whl-flex whl-flex-col whl-gap-4',
    },

    /* card header section */

    cardHeader: {
      container: 'whl-full whl-flex whl-justify-between whl-items-center',
      title:
        'whl-w-[256px] whl-font-bold whl-text-[20px] whl-tracking-[0.65px] whl-text-blue-dark whl-uppercase',
      button: {
        container:
          'whl-bg-gold whl-rounded-full whl-w-[24px] whl-h-[24px] whl-flex whl-justify-center whl-items-center whl-mb-[2px]',
        icon: 'whl-icon whl-w-[40px] whl-text-white whl-text-[18px] whl-flex whl-justify-center',
      },
    },
    cardDescription: {
      text: 'whl-text-grey  00 whl-w-[256px] whl-text-base whl-font-regular',
    },

    /* card list section */

    cardList: {
      container: 'whl-overflow-hidden  whl-h-0 whl-transition-all',
      listContainer:
        'whl-flex whl-flex-col whl-gap-3 whl-list-disc whl-list-outside whl-pl-[20px]',
      listItem: {
        listWrapper: 'marker:whl-text-mauve  whl-w-full',
        itemContainer: 'whl-flex whl-justify-between whl-w-full',
        listTitle: 'whl-text-grey whl-w-[256px] whl-text-xs whl-font-regular',
        listIconContainer:
          'whl-text-grey whl-text-xs whl-font-regular whl-relative',
        listIcon: 'whl-icon wh-icon-info whl-text-mauve',
      },
    },
  },
  [OfferingCardTypes.popular]: {
    /* outer wrapper section */

    outerWrapper: {
      container:
        'whl-w-[343px] whl-min-h-[171px] whl-h-auto whl-p-4 whl-bg-blue-dark whl-rounded-md whl-shadow-lg whl-flex whl-flex-col whl-mx-auto',
    },

    /* inner wrapper section */

    innerWrapper: {
      container: 'whl-flex whl-flex-col whl-gap-3',
    },

    /* card header section */

    cardHeader: {
      container: 'whl-full whl-flex whl-justify-between whl-items-center',
      title:
        'whl-w-[256px] whl-font-bold whl-text-[20px] whl-tracking-[0.65px] whl-text-gold whl-uppercase',
      button: {
        container:
          'whl-bg-blue-light whl-rounded-full whl-w-[24px] whl-h-[24px] whl-flex whl-justify-center whl-items-center whl-mb-[2px]',
        icon: 'whl-icon whl-w-[40px] whl-text-blue-dark whl-text-[18px] whl-flex whl-justify-center',
      },
    },
    cardDescription: {
      text: 'whl-text-white whl-leading-[20.8px] whl-w-[256px] whl-text-base whl-font-regular',
    },

    /* card list section */

    cardList: {
      container: 'whl-overflow-hidden  whl-h-0 whl-transition-all',
      listContainer:
        'whl-flex whl-flex-col whl-gap-3 whl-list-disc whl-list-outside whl-pl-[20px]',
      listItem: {
        listWrapper: 'marker:whl-text-mauve  whl-w-full',
        itemContainer: 'whl-flex whl-justify-between whl-w-full',
        listTitle: 'whl-text-white whl-w-[256px] whl-text-xs whl-font-regular',
        listIconContainer:
          'whl-text-grey whl-text-xs whl-font-regular whl-relative',
        listIcon: 'whl-icon wh-icon-info whl-text-mauve',
      },
    },
  },
};
